import React, { useEffect, useState } from "react";
import cx from "classnames";
import t from "../../../utils/translate";
import Image from "../../Image";
import useAppContext from "../../AppContext";
import imageRefresh from "./imgs/loading.gif";

import styles from "./styles.module.scss";

const LoadingInterstitial = ({
  headerText: headerTextInit = "",
  subheaderText: subheaderTextInit = "",
  hideSubheader = false,
  loadingTiming,
  className
}: {
  headerText?: string;
  subheaderText?: string;
  hideSubheader?: boolean;
  loadingTiming?: number;
  className?: string;
}): JSX.Element => {
  const [visible, setVisible] = useState(true);
  const [elementVisible, setElementVisible] = useState(true);
  const delay = loadingTiming || t("RESULTS_LOADING_TIMING") || 2000;

  const { newQuiz } = useAppContext();

  useEffect(() => {
    setTimeout(() => {
      setVisible(false);

      setTimeout(() => {
        setElementVisible(false);
      }, 600);
    }, delay);
  }, [delay]);

  const headerText =
    headerTextInit ||
    (newQuiz?.isFoodNoise
      ? t("RESULTS_LOADING_HEADER_FOOD_NOISE")
      : newQuiz?.isClinical
        ? t("SEQUENCE_LOADING_INTERSTITIAL_HEADER")
        : newQuiz?.isUni
          ? t("RESULTS_LOADING_HEADER_UNI")
          : t("RESULTS_LOADING_HEADER_NEW"));

  const subheaderText =
    subheaderTextInit ||
    (newQuiz?.isFoodNoise
      ? t("RESULTS_LOADING_SUBHEADER_FOOD_NOISE")
      : newQuiz?.isClinical
        ? t("SEQUENCE_LOADING_INTERSTITIAL_TEXT")
        : newQuiz?.eli
          ? t("RESULTS_LOADING_SUBHEADER_ELI")
          : newQuiz?.isUni
            ? t("RESULTS_LOADING_SUBHEADER_UNI")
            : t("RESULTS_LOADING_SUBHEADER_NEW"));

  return (
    <>
      {elementVisible && (
        <div
          className={cx(styles.container, className, {
            [styles.hidden]: !visible
          })}
        >
          <div className={styles.newQuizInner}>
            <div className={styles.newQuizHeader}>{headerText}</div>
            <Image className={styles.imageRebrand} src={imageRefresh} alt="" />
            {!hideSubheader && <div className={styles.newQuizSubheader}>{subheaderText}</div>}
          </div>
        </div>
      )}
    </>
  );
};

export default LoadingInterstitial;
